import { ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ColliClient } from '@frontend/colli/api';
import { Colli, ColliListResponse, ColliQueryParams } from '@frontend/colli/types';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import React, { useState } from 'react';

const ID = 'colli-select';
export interface ColliSelectProps extends ObjectSelectProps<Colli, ColliQueryParams> {
    fetch?: (queryParams?: ApiQueryParams<DefaultQueryParams & ColliQueryParams>) => Promise<ColliListResponse>;
}

export const ColliSelect = (props: ColliSelectProps) => {
    const [v, cV] = useState<Colli | null>(null);
    return (
        <ObjectSelectInput<Colli, ColliQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.COLLI.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={props.fetch ? (args) => props.fetch!(args) : (args) => ColliClient.fetchCollis(args)}
            itemLabel={(i) => (props.overWriteLabel ? props.overWriteLabel(i) : i.label + ' (' + i.type + ')')}
        />
    );
};